const translations = {
  "en": {
    "Ask a question to get started": "Ask a question to get started"
  },
  "zh-tw": {
    "Ask a question to get started": "提出問題以開始"
  }
};

export default translations;
